export const LOCAL_STORAGE_KEYS = {
  CSD_SORT_OPTION: 'csdSortOption',
}
